import React from 'react';
import PropTypes from 'prop-types';
import { ICON_TYPE } from '../constants';
import Icon from '../../../common/icon';

const IconCell = ({ value }) => value.map((v) => {
  if (v.type === ICON_TYPE.icon) {
    return (
      <div className="payment-icon">
        <Icon glyph={v.value} />
      </div>
    );
  }

  return (
    <div className="payment-icon">
      <img className="o-icon" src={v.value} alt="" />
    </div>
  );
});

IconCell.propTypes = {
  value: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default IconCell;
